import styled from "@emotion/styled";

export const Section = styled.section`
    width: 100%;
    scroll-margin-block-start: ${p => p.offsetScroll}px;
    scroll-margin-top: ${p => p.offsetScroll}px;
`;